import HttpUtils from "src/utils/HttpUtils";
import { FILE_FORMAT } from "../constants/constants-container";
import toastService from "./ToastService";

const downloadjs = require("downloadjs");

class ValidationService {

    lastApprovalChangesQueryByValidationIssuer = new Map();
    lastCmQueryByType = new Map();

    constructor() {
        this.baseUrl = HttpUtils.getBaseUrl();
    }

    fetchValidationResults = async (requestId, offset, limit) => {
        const reqId = HttpUtils.generateRequestId();
        try {
            const requestDescription = "Query validation results";
            HttpUtils.addRequest(reqId, requestDescription);
            const headers = new Headers({
                "Content-Type": "application/json",
                "x-sdd-correlation-id": reqId,
                "x-sdd-correlation-description": requestDescription,
            });
            const requestParams = this.getValidationRequestParams(
                null,
                offset,
                limit,
                requestId
            );
            const fullUrl = this.baseUrl + "validate/results" + requestParams;

            const response = await window.fetch(fullUrl, {
                method: "GET",
                credentials: "same-origin",
                headers: HttpUtils.amendHeadersIfNeeded(headers),
                redirect: "manual",
            });
            HttpUtils.reloadIfRedirectedToLogin(response);

            return await response.json();
        } catch (error) {
            console.log("Failed to fetch Validation results: ", error);
        } finally {
            HttpUtils.removeRequest(reqId);
        }
    };

    triggerValidations = async (payload) => {
        const reqId = HttpUtils.generateRequestId();
        try {
            const requestDescription = "Trigger validations";
            HttpUtils.addRequest(reqId, requestDescription);
            const headers = new Headers({
                "Content-Type": "application/json",
                "x-sdd-correlation-id": reqId,
                "x-sdd-correlation-description": requestDescription,
            });

            const fullUrl = this.baseUrl + "validate";
            const response = await window.fetch(fullUrl, {
                method: "POST",
                credentials: "same-origin",
                headers: HttpUtils.amendHeadersIfNeeded(headers),
                redirect: "manual",
                body: !!payload ? JSON.stringify(payload) : null,
            });
            HttpUtils.reloadIfRedirectedToLogin(response);
            if (response.status !== 200) {
                toastService.func_notify(
                    "Failed to trigger the validations",
                    "error"
                );
                return null;
            }

            return await response.text();
        } catch (error) {
            console.log("Failed to trigger validations: ", error);
        } finally {
            HttpUtils.removeRequest(reqId);
        }
    }

    exportValidationResults = async (requestId, format) => {
        const reqId = HttpUtils.generateRequestId();
        try {
            const requestDescription = "Export validation results";
            HttpUtils.addRequest(reqId, requestDescription);
            const headers = new Headers({
                "x-sdd-correlation-id": reqId,
                "x-sdd-correlation-description": requestDescription,
            });
            const requestParams = this.getValidationRequestParams(
                format,
                null,
                null,
                requestId
            );
            const fullUrl =
                this.baseUrl + "validate/export-results" + requestParams;

            const response = await window.fetch(fullUrl, {
                method: "GET",
                credentials: "same-origin",
                headers: HttpUtils.amendHeadersIfNeeded(headers),
                redirect: "manual",
            });
            HttpUtils.reloadIfRedirectedToLogin(response);

            if (response.status !== 500) {
                const filename =
                    "validation-results-" +
                    new Date().toLocaleDateString() +
                    "-" +
                    new Date().toLocaleTimeString() +
                    "." +
                    FILE_FORMAT.XLSX.name;

                downloadjs(await response.blob(), filename, FILE_FORMAT.XLSX.getMimetype);
            } else {
                toastService.func_notify(
                    "Exporting validation results failed. Reason: " +
                        (await response.json().message),
                    "error"
                );
            }
        } catch (error) {
            console.log("Failed to fetch Validation results: ", error);
        } finally {
            HttpUtils.removeRequest(reqId);
        }
    }

    getValidationRequestParams = (format, offset, limit, requestId) => {
        if (format || offset || limit || requestId) {
          let requestParams = "";
          let firstParam = true;
          if (format) {
            requestParams += "?format=" + format;
            firstParam = false;
          }
          if (Number.isInteger(offset)) {
            if (firstParam) {
              requestParams += "?offset=" + offset;
              firstParam = false;
            } else {
              requestParams += "&offset=" + offset;
            }
          }
          if (Number.isInteger(limit)) {
            if (firstParam) {
              requestParams += "?limit=" + limit;
              firstParam = false;
            } else {
              requestParams += "&limit=" + limit;
            }
          }
          if (requestId) {
            if (firstParam) {
              requestParams += "?requestId=" + requestId;
              firstParam = false;
            } else {
              requestParams += "&requestId=" + requestId;
            }
          }
          return requestParams;
        } else {
          return "";
        }
    };

    setLastApprovalChangesQueryByValidationIssuer = (validationIssuer, entityFilter) => {
        if (validationIssuer) {
            this.lastApprovalChangesQueryByValidationIssuer.set(validationIssuer, entityFilter);
        }
    }

    getLastApprovalChangesQueryByValidationIssuer() {
      return this.lastApprovalChangesQueryByValidationIssuer
        ? this.lastApprovalChangesQueryByValidationIssuer
        : {};
    }

    setLastCmQueryByType = (type, entityFilter) => {
        if (type) {
            this.lastCmQueryByType.set(type, entityFilter);
        }
    }

    getLastCmQueryByType() {
      return this.lastCmQueryByType ? this.lastCmQueryByType : {};
    }
}

const validationService = new ValidationService();

export default validationService;